import React from 'react';
import {Link} from 'react-router';
import NavigationMenu from './NavigationMenu';

import Scroll from 'react-scroll';
let ScrollLink = Scroll.Link;

class MenuItem extends React.Component {
    constructor(props) {
        super(props);
        this.defaultClickHandler = this.defaultClickHandler.bind(this);
    }

    defaultClickHandler(e) {
        e.preventDefault();
        this.props.clickHandler();
    }

    render() {
        // TODO figure out how to use aciveClassName on the li element
        let isActive = false;

        let link;
        let isExternal = this.props.href && this.props.href.match(/(http:\/\/)|(https:\/\/)/);

        if (this.props.scrollTo) {
            link = <ScrollLink
                onClick={this.props.clickHandler ? this.defaultClickHandler : null}
                to={this.props.scrollTo}
                smooth={true}
                spy={true}
                activeClass="active"
            >{this.props.text}</ScrollLink>;
        }
        else if (!isExternal) {
            link = <Link
                onClick={this.props.clickHandler ? this.defaultClickHandler : null}
                to={this.props.href}
                activeClassName="active"
            >{this.props.text}</Link>;
        }
        else {
            link = <a target="_blank" href={this.props.href}>{this.props.text}</a>;
        }

        return <li className={ (this.props.className ? this.props.className : "") + (isActive ? " active" : "") }>
            {link}
            {this.props.subMenu ?
                <NavigationMenu className={this.props.subMenu.className} items={this.props.subMenu.items}/> : null }
        </li>
    }
}

export default MenuItem;


// WEBPACK FOOTER //
// ./src/components/Presentation/Navigation/MenuItem.js